import React from "react";
import { Hooks, Util, XtLocale, Config, Storage } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { getUrl } = Util;
const { TwitterHref, LinkedInHref, TelegramHref } = Config.connections;
import cx from "classnames";
import { Collapse } from "antd";
import cs from "./index.module.scss";
import { getZenLink, getLegalDocZenLink } from "./configs";
import Twitter from "./imgs/contact-us/Twitter";
import Linkedin from "./imgs/contact-us/Linkedin";
import Telegram from "./imgs/contact-us/Telegram";

const { Panel } = Collapse;

/** Figma 9755:13936：Contact Us 仅展示 X / Telegram / LinkedIn，链接来自 Config.connections */
export const contactSocialList = [
  { link: TwitterHref, Logo: Twitter },
  { link: TelegramHref, Logo: Telegram },
  { link: LinkedInHref, Logo: Linkedin },
];

export const communityList = contactSocialList;

const Footer = () => {
  const intl = XtLocale.intl;
  var lang = intl.locale;
  const t = useTranslation();
  // const { account } = useStore();
  // const { push } = useHistory();
  const cfdMarket = Storage.get("cfdMarket") || "btc_usdt_cfd";

  const onAppDl = () => {
    // window.location.href = `https://www.sigma.com/app`
    window.location.href = getUrl("/app");
    // push(`${getXTOrigin()}/app`);
  };

  return (
    <div className={cs.footRoot}>
      <div className={cs.footBackdrop}>
        <div className={cs.footInner}>
          <div className={cs.container}>
        <div className={cs.content}>
          <section className={cx(cs.section)}>
            <h2>{t("footer.Company")}</h2>
            <div>
              <a href={getZenLink(lang, "blog")} target="_blank" rel="nofollow noopener noreferrer">
                {t("footer.officialAnn")}
              </a>
              <a href={getUrl("/referral")} target="_blank" rel="noopener noreferrer">
                {t("footer.Referral")}
              </a>
              <a href={getUrl("/affiliate")} target="_blank" rel="noopener noreferrer">
                {t("footer.partnerNav")}
              </a>
              <a href={getUrl("/rate")} target="_blank" rel="noopener noreferrer">
                {t("footer.feeRate")}
              </a>
            </div>
          </section>

          <section className={cx(cs.section)}>
            <h2>{t("footer.Product")}</h2>
            <div>
              <a href={getUrl("/futures/contract/" + cfdMarket)} target="_blank" rel="noopener noreferrer">
                {t("header.cfdTrading")}
              </a>
              <a href={getUrl("/aicopy")} target="_blank" rel="noopener noreferrer">
                {t("header.aicopy")}
              </a>
              <a href={getUrl("/futures/contract/spot")} target="_blank" rel="noopener noreferrer">
                {t("footer.convertNav")}
              </a>
            </div>
          </section>

          <section className={cx(cs.section)}>
            <h2>{t("footer.Service")}</h2>
            <div>
              <a onClick={onAppDl}>{t("footer.appDl")}</a>
            </div>
          </section>

          <section className={cx(cs.section)}>
            <h2>{t("footer.contactUs")}</h2>
            <div>
              <div className={cs.community}>
                {contactSocialList.map(({ link, Logo }) => (
                  <a
                    key={typeof link == "string" ? link : link[intl.locale]}
                    href={typeof link == "string" ? link : link[intl.locale]}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <Logo />
                  </a>
                ))}
              </div>
              <div className={cs.contactBlock}>
                <p className={cs.contactEmail}>
                  <span className={cs.contactEmailLead}>{t("footer.cooperativePartnerLabel")}</span>
                  <a href="mailto:marketing@spikex.com" target="_self" rel="noopener noreferrer">
                    marketing@spikex.com
                  </a>
                </p>
                <p className={cs.contactEmail}>
                  <span className={cs.contactEmailLead}>{t("footer.customer")}: </span>
                  <a href="mailto:support@spikex.com" target="_self" rel="noopener noreferrer">
                    support@spikex.com
                  </a>
                </p>
              </div>
            </div>
          </section>
        </div>

        <div className={cs.mobileContent}>
          <Collapse accordion ghost expandIconPosition="end">
            <Panel className={cs.mobilePannel} header={t("footer.Company")} key="Company">
              <div className={cs.mobilePanelCnt}>
                <a href={getZenLink(lang, "blog")} target="_blank" rel="nofollow noopener noreferrer">
                  {t("footer.officialAnn")}
                </a>
                <a href={getUrl("/referral")} target="_blank" rel="noopener noreferrer">
                  {t("footer.Referral")}
                </a>
                <a href={getUrl("/affiliate")} target="_blank" rel="noopener noreferrer">
                  {t("footer.partnerNav")}
                </a>
                <a href={getUrl("/rate")} target="_blank" rel="noopener noreferrer">
                  {t("footer.feeRate")}
                </a>
              </div>
            </Panel>

            <Panel className={cs.mobilePannel} header={t("footer.Product")} key="Product">
              <div className={cs.mobilePanelCnt}>
                <a href={getUrl("/futures/contract/" + cfdMarket)} target="_blank" rel="noopener noreferrer">
                  {t("header.cfdTrading")}
                </a>
                <a href={getUrl("/aicopy")} target="_blank" rel="noopener noreferrer">
                  {t("header.aicopy")}
                </a>
                <a href={getUrl("/futures/contract/spot")} target="_blank" rel="noopener noreferrer">
                  {t("footer.convertNav")}
                </a>
              </div>
            </Panel>

            <Panel className={cs.mobilePannel} header={t("footer.Service")} key="Service">
              <div className={cs.mobilePanelCnt}>
                <a onClick={onAppDl}>{t("footer.appDl")}</a>
              </div>
            </Panel>

            <Panel className={cs.mobilePannel} header={t("footer.contactUs")} key="contactUs">
              <div className={cs.mobilePanelCnt}>
                <div className={cs.mobileCommunity}>
                  {contactSocialList.map(({ link, Logo }) => (
                    <a
                      key={(typeof link == "string" ? link : link[intl.locale]) + "_mb"}
                      href={typeof link == "string" ? link : link[intl.locale]}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                    >
                      <Logo />
                    </a>
                  ))}
                </div>
                <div className={cs.contactBlock}>
                  <p className={cs.contactEmail}>
                    <span className={cs.contactEmailLead}>{t("footer.cooperativePartnerLabel")}</span>
                    <a href="mailto:marketing@spikex.com" target="_self" rel="noopener noreferrer">
                      marketing@spikex.com
                    </a>
                  </p>
                  <p className={cs.contactEmail}>
                    <span className={cs.contactEmailLead}>{t("footer.customer")}: </span>
                    <a href="mailto:support@spikex.com" target="_self" rel="noopener noreferrer">
                      support@spikex.com
                    </a>
                  </p>
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>
          </div>
        </div>
      </div>
      <div className={cs.bottom}>
        <div className={cs.bottomInner}>
          <p>
            © {new Date().getFullYear()}{" "}
            <span className={cs.brandMark}>{t("footer.copyrightBrand")}</span>. {t("footer.Rights")} |{" "}
            <a href={getLegalDocZenLink(lang, "agreement")} target="_blank" rel="nofollow noopener noreferrer">
              {t("footer.userAgreement")}
            </a>{" "}
            |{" "}
            <a href={getLegalDocZenLink(lang, "privacy")} target="_blank" rel="nofollow noopener noreferrer">
              {t("footer.PrivacyTerms")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
